import SvgIcon from '@home/components/SvgIcon';
import { initialUpperCase } from '@op/utils';
import { paramsToMomentMap } from '@op/utils/time';
import moment from 'moment';
import React, { useMemo, useState } from 'react';
import { Form } from 'tea-component';
import './index.scss';
import { PreviewFilter } from '../../pages/PreviewSummary/PreviewBody';
import { FilterGameInfoContext } from '@op/components/FilterCommon/context';

export default function SummaryDetail(props: {
  gameInfo: any;
  wholeGameInfo: any;
  details: {
    create_time: string;
    start_date: string;
    end_date: string;
    date_type: string;
    user_name: string;
    short_url: string;
    interval_unit?: string;
    interval_value?: number;
  };
  formatMessage: any;
  isAdvanced?: boolean;
}) {
  const { gameInfo, wholeGameInfo, details, formatMessage, isAdvanced = false } = props;

  const [filterVisible, setFilterVisible] = useState(false);

  const frequencyText = useMemo(() => {
    const { interval_unit, interval_value } = details;
    let intervalType = 'daily';
    if (interval_unit === 'month') {
      intervalType = 'monthly';
    } else if (interval_unit === 'week') {
      intervalType = 'weekly';
    } else if (interval_unit === 'hour') {
      intervalType = 'hourly';
    }
    const momentDateType = paramsToMomentMap?.[intervalType];
    const diff = interval_value || 0;
    const dateType = diff > 1 ? momentDateType : momentDateType.slice(0, -1);
    if (intervalType === 'hourly') {
      return formatMessage(
        { id: 'Repeat every {number} {hour}' },
        { number: diff > 1 ? diff : '', hour: formatMessage({ id: dateType }) },
      );
    }

    if (intervalType === 'monthly') {
      return formatMessage(
        {
          id: 'Repeat every {number} {dateType}, data spans from 00:00 on the first day of Month 1 to 00:00 on the first day of Month {totalDiff}',
        },
        {
          number: diff > 1 ? diff : '',
          dateType: formatMessage({ id: dateType }),
          totalDiff: diff + 1,
        },
      );
    }

    return formatMessage(
      {
        id: 'Repeat every {number} {dateType}, data spans from 00:00 on {dateTypeText} 1 to 00:00 on {dateTypeText} {totalDiff}',
      },
      {
        number: diff > 1 ? diff : '',
        dateType: formatMessage({ id: dateType }),
        dateTypeText: formatMessage({
          id: initialUpperCase(momentDateType.slice(0, -1)),
        }),
        totalDiff: diff + 1,
      },
    );
  }, [details, formatMessage]);

  const gameInfoReduce = useMemo(() => {
    return {
      gameInfo,
      use: true,
      wholeGameInfo,
    };
  }, [gameInfo, wholeGameInfo]);

  return (
    <>
      <Form className="dbo-summary-detail">
        <Form.Item label={formatMessage({ id: 'Summary Start Time' })}>
          <span>
            {moment(details.start_date).format('YYYY-MM-DD HH:mm:ss')}
          </span>
        </Form.Item>
        <Form.Item label={formatMessage({ id: 'Summary End Time' })}>
          <span>{moment(details.end_date).format('YYYY-MM-DD HH:mm:ss')}</span>
        </Form.Item>
        <Form.Item label={formatMessage({ id: 'Creator' })}>
          <span>{details.user_name}</span>
        </Form.Item>
        <Form.Item label={formatMessage({ id: 'Frequency-2' })}>
          <span>{frequencyText}</span>
        </Form.Item>
        {details?.short_url && (
          <Form.Item
            label={
              <div
                className="dbo-summary-detail-selected-filters"
                onClick={() => {
                  setFilterVisible(!filterVisible);
                }}
              >
                <span>{formatMessage({ id: 'Selected Filters' })}</span>
                <SvgIcon
                  type={'fill-icon-arrow'}
                  className={`dbo-summary-detail-selected-filters-icon ${filterVisible ? '--rotate' : ''}`}
                />
              </div>
            }
          />
        )}
      </Form>
      {filterVisible && (
        <FilterGameInfoContext.Provider value={gameInfoReduce}>
          <PreviewFilter
            gameInfo={gameInfo}
            shortId={details?.short_url}
            pageName={'Custom_AI_Summary'}
            isAdvanced={isAdvanced}
            allPreview={false}
            operateShowOptions={[]}
            backCondOriginData={(value) => {
              console.log('backCondOriginData :: ', value);
            }}
            renderExcludeFilter={['date']}
          />
        </FilterGameInfoContext.Provider>
      )}
    </>
  );
}
